import { useEffect } from 'react'
import { getLanguageCodeFromCode } from '../model/locale.utils'

export const useLocales = (kedo: any) => {
    useEffect(() => {
        const selectedLocale = kedo.env().getSelectedLocale()

        if (selectedLocale) {
            const localeCode = getLanguageCodeFromCode(
                selectedLocale.code
            )
            kedo.utils().getI18N().changeLanguage(localeCode)
        }
    }, [kedo])
}
